/**
 * RepeaterFields class.
 *
 * Handles adding repeat fields to forms when appropriate markup is present.
 */
class RepeaterFields {
    constructor() {
        // Add event listeners for existing DOM elements
        document.querySelectorAll('.js-repeater-field-add-row')
            .forEach(node => {
                node.addEventListener('click', e => this.addRowCallback(e))
                this.prepareForGarlic(node)
            })
        document.querySelectorAll('.js-repeater-field-remove-row')
            .forEach(node => node.addEventListener('click', e => this.removeRow(e)))
    }

    /**
     * Taken from garlic.js
     */
    getGarlicPath = function ( elem ) {
        // Requires one element.
        if ( elem.length != 1 ) {
            return false;
        }

        var path = ''
            , fullPath = elem.is( 'input[type=checkbox]' )
            , node = elem;

        while ( node.length ) {
            var realNode = node[0]
                , name = realNode.nodeName;

            if ( !name ) {
                break;
            }

            name = name.toLowerCase();

            var parent = node.parent()
                , siblings = parent.children( name );

            // don't need to pollute path with select, fieldsets, divs and other noisy elements,
            // exept for checkboxes that need exact path, cuz have same name and sometimes same eq()!
            if ( !$( realNode ).is( 'form, input, select, textarea' ) && !fullPath ) {
                node = parent;
                continue;
            }

            // set input type as name + name attr if exists
            name += $( realNode ).attr( 'name' ) ? '.' + $( realNode ).attr( 'name' ) : '';

            // if has sibilings, get eq(), exept for radio buttons
            if ( siblings.length > 1 && !$( realNode ).is( 'input[type=radio]' ) ) {
                name += ':eq(' + siblings.index( realNode ) + ')';
            }

            path = name + ( path ? '>' + path : '' );

            // break once we came up to form:eq(x), no need to go further
            if ( 'form' == realNode.nodeName.toLowerCase() ) {
                break;
            }

            node = parent;
        }

        return 'garlic:' + document.domain + window.location.pathname + '>' + path;
    }

    prepareForGarlic(node) {
        const wrapper = this.getWrapper(node)
        const fields = wrapper.querySelectorAll('.js-repeater-field')
        const inputs = fields[0].querySelectorAll('[name]')

        const testGarlicKey = (input, index) => {
            const garlicKey = this.getGarlicPath($(input))
            index = index || parseInt(input.name.match(/\[(\d+)]$/)[1])

            const nextIndex = index + 1
            const nextGarlicKey = garlicKey.replace('[' + index + ']', '[' + nextIndex + ']')

            if (localStorage.getItem(nextGarlicKey) !== null) {
                const rows = wrapper.querySelectorAll('.js-repeater-field').length

                if (nextIndex + 1 > rows) {
                    /**
                     * There can be multiple inputs inside a row, so don't add rows that have already been added by
                     * handling previous inputs.
                     */
                    this.addRow(node)
                }

                const nextInput = $(input).parents('.js-repeater-field').next().find('input[name="' + input.name.replace('[' + index + ']', '[' + nextIndex + ']') + '"]')[0]

                testGarlicKey(nextInput, nextIndex)
            }
        }

        inputs.forEach(input => {
            testGarlicKey(input)
        })
    }

    getWrapper(node) {
        if (typeof node === 'undefined') {
            throw Error('Unable to locate repeater field wrapper')
        }

        if (typeof node.dataset.target !== 'undefined') {
            return document.querySelector(node.dataset.target)
        }

        // Check the parent
        return this.getWrapper(node.parentNode)
    }

    addRowCallback(e) {
        e.preventDefault()
        this.addRow(e.target)
    }

    addRow(node) {
        const wrapper = this.getWrapper(node)
        const fields = wrapper.querySelectorAll('.js-repeater-field')
        const template = fields[0].cloneNode(true)

        const nextIndex = parseInt(
            fields[fields.length-1].querySelector('input, textarea, select')
                .getAttribute('name')
                .match(/\[(\d+)]$/)[1]
        ) + 1

        // Increment index on wrapper ID
        template.setAttribute('id', template.getAttribute('id').replace(/\d+/, nextIndex))

        // Increment index on remove row button target
        const removeRow = template.querySelector('.js-repeater-field-remove-row')
        removeRow.dataset.target = removeRow.dataset.target.replace(/\d+/, nextIndex)

        template.querySelectorAll('label').forEach(node => {
            // Increment index
            node.setAttribute('for', node.getAttribute('for').replace(/\d+/, nextIndex))
        })

        template.querySelectorAll('input, textarea, select').forEach(node => {
            // Increment index
            node.setAttribute('id', node.getAttribute('id').replace(/\d+/, nextIndex))
            node.setAttribute('name', node.getAttribute('name').replace(/\d+/, nextIndex))

            // Reset values
            switch (node.tagName) {
                // @todo Add handling for textarea and select elements

                default:
                    node.value = ''
                    break
            }
        });

        template.querySelector('.js-repeater-field-remove-row')
            .addEventListener('click', e => this.removeRow(e))

        wrapper.insertBefore(template, wrapper.querySelector('.js-repeater-field-add-row'))

        initGarlicJs()
    }

    removeRow(e) {
        e.preventDefault()

        const wrapper = this.getWrapper(e.target)
        wrapper.remove()

        const $sumUpField = $('.js-sumUp__field');
        if ($sumUpField.length > 0 ) {
            $sumUpField.trigger('keyup');
        }
    }
}

new RepeaterFields


const loginFormControls = () => {
    const $form = $('.login-form')
    if (!$form.length) return

    const $toggle = $('.login-form__toggle-link')
    const $emailForm = $('.login-form__email-form')
    $toggle.on('click', function(e) {
        e.preventDefault()
        $emailForm.toggleClass('is-visible')
    })

    const $invalidInput = $('.is-invalid')
    if ($invalidInput.length) {
        $toggle.trigger('click')
    }
}

loginFormControls();

function initGarlicJs() {
    $('[data-persist="garlic-cust"]').each(function () {
        $(this).garlic()
    })

    setTimeout(() => $(document).trigger('sumUp'), 0)
}

initGarlicJs()

function initTableFilters() {
    $('.js-application-type-filter').on('change', function() {
        const $this = $(this)
        const $option = $this.find('option:selected')
        const newUrl = $option.data('url')

        window.location.href = newUrl
    })
}
initTableFilters()
